export const GET_ADMIN_LOADING = 'get/admin/loading'
export const GET_ADMIN_ERROR = 'get/admin/error'
export const GET_ADMIN_SUCCESS = 'get/admin/success'

export const GET_USERS_LOADING = 'get/users/loading'
export const GET_USERS_ERROR = 'get/users/error'
export const GET_USERS_SUCCESS = 'get/users/success'

export const UPDATE_USERS_LOADING = 'update/users/loading'
export const UPDATE_USERS_ERROR = 'update/users/error'
export const UPDATE_USERS_SUCCESS = 'update/users/success'

export const DELETE_USERS_LOADING = 'delete/users/loading'
export const DELETE_USERS_ERROR = 'delete/users/error'
export const DELETE_USERS_SUCCESS = 'delete/users/success'

export const GET_PRODUCTS_LOADING = 'get/products/loading'
export const GET_PRODUCTS_ERROR = 'get/products/error'
export const GET_PRODUCTS_SUCCESS = 'get/products/success'

export const ADD_PRODUCTS_LOADING = 'add/products/loading'
export const ADD_PRODUCTS_ERROR = 'add/products/error'
export const ADD_PRODUCTS_SUCCESS = 'add/products/success'

export const UPDATE_PRODUCTS_LOADING = 'update/products/loading'
export const UPDATE_PRODUCTS_ERROR = 'update/products/error'
export const UPDATE_PRODUCTS_SUCCESS = 'update/products/success'

export const DELETE_PRODUCTS_LOADING = 'delete/products/loading'
export const DELETE_PRODUCTS_ERROR = 'delete/products/error'
export const DELETE_PRODUCTS_SUCCESS = 'delete/products/success'

export const GET_CART_LOADING = 'get/cart/loading'
export const GET_CART_ERROR = 'get/cart/error'
export const GET_CART_SUCCESS = 'get/cart/success'

export const UPDATE_CART_LOADING = 'update/cart/loading'
export const UPDATE_CART_ERROR = 'update/cart/error'
export const UPDATE_CART_SUCCESS = 'update/cart/success'

export const DELETE_CART_LOADING = 'delete/cart/loading'
export const DELETE_CART_ERROR = 'delete/cart/error'
export const DELETE_CART_SUCCESS = 'delete/cart/success'

export const GET_WISHLIST_LOADING = 'get/wishlist/loading'
export const GET_WISHLIST_ERROR = 'get/wishlist/error'
export const GET_WISHLIST_SUCCESS = 'get/wishlist/success'

export const DELETE_WISHLIST_LOADING = 'delete/wishlist/loading'
export const DELETE_WISHLIST_ERROR = 'delete/wishlist/error'
export const DELETE_WISHLIST_SUCCESS = 'delete/wishlist/success'

export const GET_CHECKOUT_LOADING = 'get/checkout/loading'
export const GET_CHECKOUT_ERROR = 'get/checkout/error'
export const GET_CHECKOUT_SUCCESS = 'get/checkout/success'













